export default __webpack_public_path__ + "static/media/shoes_front.e5736ae5.png";